import PropTypes from 'prop-types';

import { ADMIN_BROWSE_SECTION_TYPE, VALIDATION_ERROR_MESSAGE } from 'app/constants/admin/browse/home';
import { LOCALE_CODE } from 'app/constants/language';

export const catalogTitlesSectionShape = PropTypes.shape({
  hasAlternativeBackground: PropTypes.bool.isRequired,
  heading: PropTypes.string.isRequired,
  searchUrl: PropTypes.string.isRequired,
  sectionId: PropTypes.string.isRequired,
  sectionType: PropTypes.oneOf([ADMIN_BROWSE_SECTION_TYPE.CATALOG_TITLES]).isRequired
});

export const catalogTitlesSectionValidationShape = PropTypes.shape({
  isValid: PropTypes.bool.isRequired,
  errorByAttribute: PropTypes.shape({
    heading: PropTypes.oneOf(['', VALIDATION_ERROR_MESSAGE.INVALID_HEADING]).isRequired,
    searchUrl: PropTypes.oneOf(['', VALIDATION_ERROR_MESSAGE.INVALID_CATALOG_SEARCH_URL]).isRequired
  }).isRequired
});

export const linkValidationShape = PropTypes.shape({
  isValid: PropTypes.bool.isRequired,
  errorByAttribute: PropTypes.shape({
    label: PropTypes.oneOf(['', VALIDATION_ERROR_MESSAGE.INVALID_LABEL]).isRequired,
    url: PropTypes.oneOf(['', VALIDATION_ERROR_MESSAGE.INVALID_URL]).isRequired
  }).isRequired
});

export const linksShape = PropTypes.arrayOf(
  PropTypes.shape({
    label: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  })
);

export const listUrlShape = PropTypes.exact({
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
});

export const listsSectionShape = PropTypes.shape({
  hasAlternativeBackground: PropTypes.bool.isRequired,
  heading: PropTypes.string.isRequired,
  listUrls: PropTypes.arrayOf(listUrlShape).isRequired,
  sectionId: PropTypes.string.isRequired,
  sectionType: PropTypes.oneOf([ADMIN_BROWSE_SECTION_TYPE.LISTS]).isRequired
});

export const listsSectionValidationShape = PropTypes.shape({
  isValid: PropTypes.bool.isRequired,
  errorByAttribute: PropTypes.shape({
    heading: PropTypes.oneOf(['', VALIDATION_ERROR_MESSAGE.INVALID_HEADING]).isRequired,
    listUrls: PropTypes.arrayOf(PropTypes.oneOf(['', VALIDATION_ERROR_MESSAGE.INVALID_LIST_URL])).isRequired
  }).isRequired
});

export const listsHeroSectionShape = PropTypes.shape({
  listUrls: PropTypes.arrayOf(listUrlShape).isRequired,
  sectionId: PropTypes.string.isRequired,
  sectionType: PropTypes.oneOf([ADMIN_BROWSE_SECTION_TYPE.LISTS_HERO]).isRequired
});

export const listsHeroSectionValidationShape = PropTypes.shape({
  isValid: PropTypes.bool.isRequired,
  errorByAttribute: PropTypes.shape({
    listUrls: PropTypes.arrayOf(PropTypes.oneOf(['', VALIDATION_ERROR_MESSAGE.INVALID_LIST_URL])).isRequired
  }).isRequired
});

export const listTitlesSectionShape = PropTypes.shape({
  hasAlternativeBackground: PropTypes.bool.isRequired,
  listUrl: listUrlShape.isRequired,
  sectionId: PropTypes.string.isRequired,
  sectionType: PropTypes.oneOf([ADMIN_BROWSE_SECTION_TYPE.LIST_TITLES]).isRequired
});

export const listTitlesSectionValidationShape = PropTypes.shape({
  isValid: PropTypes.bool.isRequired,
  errorByAttribute: PropTypes.shape({
    listUrl: PropTypes.oneOf(['', VALIDATION_ERROR_MESSAGE.INVALID_LIST_URL]).isRequired
  }).isRequired
});

export const linksSectionShape = PropTypes.shape({
  hasAlternativeBackground: PropTypes.bool.isRequired,
  links: linksShape.isRequired,
  heading: PropTypes.string.isRequired,
  sectionId: PropTypes.string.isRequired,
  sectionType: PropTypes.oneOf([ADMIN_BROWSE_SECTION_TYPE.LINKS]).isRequired
});

export const linksSectionValidationShape = PropTypes.shape({
  isValid: PropTypes.bool.isRequired,
  errorByAttribute: PropTypes.shape({
    heading: PropTypes.oneOf(['', VALIDATION_ERROR_MESSAGE.INVALID_HEADING]).isRequired,
    links: PropTypes.shape({
      createLink: linkValidationShape.isRequired
    }).isRequired
  }).isRequired
});

export const navigationSectionShape = PropTypes.shape({
  links: linksShape.isRequired,
  sectionId: PropTypes.string.isRequired,
  sectionType: PropTypes.oneOf([ADMIN_BROWSE_SECTION_TYPE.NAVIGATION]).isRequired
});

export const navigationSectionValidationShape = PropTypes.shape({
  isValid: PropTypes.bool.isRequired,
  errorByAttribute: PropTypes.shape({
    links: PropTypes.shape({
      createLink: linkValidationShape.isRequired
    }).isRequired
  }).isRequired
});

export const browseHomePageShape = PropTypes.shape({
  browseHomePageId: PropTypes.string.isRequired,
  createdBy: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  localeCode: PropTypes.oneOf(Object.values(LOCALE_CODE)).isRequired,
  name: PropTypes.string.isRequired,
  sections: PropTypes.arrayOf(
    PropTypes.oneOfType([
      catalogTitlesSectionShape,
      linksSectionShape,
      listsSectionShape,
      listsHeroSectionShape,
      listTitlesSectionShape,
      navigationSectionShape
    ])
  ).isRequired,
  updatedAt: PropTypes.number,
  updatedBy: PropTypes.string
});
